import React, { useState } from 'react';
import { Plus, MagnifyingGlass, Funnel, DotsThreeVertical, FilePdf, WhatsappLogo, EnvelopeSimple, PencilSimple, Truck, Check, X, DownloadSimple, ArrowsOut } from '@phosphor-icons/react';

const STATUS = {
  concept: { bg: '#6B7280', label: 'Concept', icon: '✎' },
  'nog te leveren': { bg: '#EA580C', label: 'Nog te leveren', icon: '◐' },
  verzonden: { bg: '#002FA7', label: 'Verzonden', icon: '→' },
  onderweg: { bg: '#0891B2', label: 'Onderweg', icon: '➜' },
  geleverd: { bg: '#16A34A', label: 'Geleverd', icon: '✓' },
  geblokkeerd: { bg: '#B91C1C', label: 'Geblokkeerd', icon: '⊘' },
};

const DOCS = [
  { id: 'LB-2026-0113', datum: '2026-10-06', klant: 'CM Renovatie BVBA', totaal: 1842.5, status: 'nog te leveren', info: 'Nog te factureren' },
  { id: 'LB-2026-0112', datum: '2026-10-06', klant: 'Multi Trucks NV', totaal: 612.0, status: 'verzonden', chauffeur: 'Kanber', tijd: '06/10 08:15' },
  { id: 'LB-2026-0111', datum: '2026-10-05', klant: 'BV A Reno', totaal: 2390.8, status: 'geleverd', tijd: '05/10 14:32', factuur: 'F-2026-0087' },
  { id: 'LB-2026-0110', datum: '2026-10-04', klant: 'Dakwerken Peeters', totaal: 455.0, status: 'concept' },
  { id: 'LB-2026-0109', datum: '2026-10-03', klant: 'Alu Constructies De Smet & Zonen', totaal: 5120.25, status: 'geleverd', tijd: '03/10 11:05', factuur: 'F-2026-0085' },
  { id: 'LB-2026-0108', datum: '2026-10-02', klant: 'Bouwgroep Van Hoof', totaal: 980.0, status: 'geblokkeerd' },
];

const KPIS = [
  { label: 'Totaal', value: 112 },
  { label: 'Nog te leveren', value: 1, color: '#EA580C' },
  { label: 'Verzonden', value: 0, color: '#002FA7' },
  { label: 'Onderweg', value: 0, color: '#0891B2' },
  { label: 'Geleverd', value: 108, color: '#16A34A' },
  { label: 'Concept', value: 2 },
  { label: 'Geblokkeerd', value: 1, color: '#B91C1C' },
  { label: 'Geannuleerd', value: 0 },
];

const fmt = (n) => '€ ' + n.toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

function Pill({ status }) {
  const s = STATUS[status];
  return (
    <span className="inline-flex items-center gap-1 px-2 py-0.5 text-[11px] font-bold text-white rounded-sm whitespace-nowrap" style={{ background: s.bg }}>
      {s.icon} {s.label} <span className="opacity-70 text-[9px]">▼</span>
    </span>
  );
}

function IconBtn({ children, label }) {
  return (
    <button className="h-10 flex-1 min-w-[40px] max-w-[56px] px-1 inline-flex items-center justify-center gap-1 border border-gray-200 bg-white text-gray-600 active:bg-gray-100" title={label}>
      {children}
    </button>
  );
}

function DocCard({ d, selected, onToggle }) {
  return (
    <div className={`bg-white border ${selected ? 'border-[#002FA7] ring-1 ring-[#002FA7]' : 'border-gray-200'} p-3 flex flex-col gap-2`}>
      <div className="flex items-start gap-3">
        <input type="checkbox" className="mt-1 w-5 h-5 shrink-0" checked={selected} onChange={onToggle} />
        <div className="flex-1 min-w-0">
          <div className="flex items-baseline justify-between gap-2">
            <span className="doc-nr">{d.id}</span>
            <span className="text-xs text-gray-500 whitespace-nowrap">{d.datum}</span>
          </div>
          <div className="font-semibold text-[15px] text-gray-900 truncate mt-1">{d.klant}</div>
          <div className="flex items-center justify-between gap-2 mt-1.5">
            <Pill status={d.status} />
            <span className="font-bold text-[15px] whitespace-nowrap">{fmt(d.totaal)}</span>
          </div>
          {(d.chauffeur || d.tijd || d.factuur || d.info) && (
            <div className="flex flex-wrap items-center gap-x-3 gap-y-0.5 mt-1.5 text-[11px] text-gray-500">
              {d.chauffeur && <span>👤 {d.chauffeur}</span>}
              {d.tijd && <span className={d.status === 'geleverd' ? 'text-[#16A34A] font-semibold' : ''}>{d.status === 'geleverd' ? '✓' : '🚚'} {d.tijd}</span>}
              {d.factuur && <span className="text-[#7C3AED] font-semibold">{d.factuur}</span>}
              {d.info && <span className="text-orange-600 font-bold uppercase text-[9px]">{d.info}</span>}
              {d.status === 'verzonden' && <button className="text-[#16A34A] font-bold">✓ Geleverd?</button>}
            </div>
          )}
        </div>
      </div>
      <div className="flex items-center gap-1 sm:gap-1.5 pl-8 md:pl-0">
        <IconBtn label="PDF"><FilePdf size={18} className="text-[#DC2626]" /></IconBtn>
        <IconBtn label="WhatsApp"><WhatsappLogo size={18} weight="fill" className="text-[#25D366]" /></IconBtn>
        <IconBtn label="E-mail"><EnvelopeSimple size={18} className="text-[#2563EB]" /></IconBtn>
        <IconBtn label="CMR"><Truck size={18} className="text-[#2563EB]" /></IconBtn>
        <IconBtn label="Bewerken"><PencilSimple size={18} /></IconBtn>
        <IconBtn label="Meer"><DotsThreeVertical size={18} weight="bold" /></IconBtn>
      </div>
    </div>
  );
}

export default function LeverbonMobielMockupPage() {
  const [sel, setSel] = useState(['LB-2026-0113', 'LB-2026-0112']);
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [moreOpen, setMoreOpen] = useState(false);
  const toggle = (id) => setSel(p => p.includes(id) ? p.filter(x => x !== id) : [...p, id]);
  const N = sel.length;

  return (
    <div className="pb-24" data-testid="leverbon-mobiel-mockup">
      <div className="mb-2 px-2 py-1 bg-amber-50 border border-amber-200 text-[11px] text-amber-800">VOORBEELD — mobiele weergave Leveringsbonnen (gsm &lt; 768px · iPad 2 kolommen)</div>

      {/* Header */}
      <div className="flex items-center justify-between gap-2 mb-3">
        <h1 className="page-heading mb-0">Leveringsbonnen</h1>
        <div className="flex items-center gap-1.5">
          <IconBtn label="Excel-export"><DownloadSimple size={18} /></IconBtn>
          <IconBtn label="Ruim/Compact"><ArrowsOut size={18} /></IconBtn>
          <button className="h-10 px-3 inline-flex items-center gap-1 bg-[#002FA7] text-white font-bold text-sm"><Plus size={16} weight="bold" /> Nieuw</button>
        </div>
      </div>

      {/* KPI strook */}
      <div className="flex gap-2 overflow-x-auto -mx-4 px-4 md:mx-0 md:px-0 pb-2 mb-3 snap-x" style={{ scrollbarWidth: 'none' }}>
        {KPIS.map(k => (
          <button key={k.label} className="snap-start shrink-0 min-w-[96px] bg-white border border-gray-200 px-3 py-2 text-left active:border-[#002FA7]" style={k.label === 'Nog te leveren' ? { borderColor: '#002FA7', borderWidth: 2 } : {}}>
            <div className="text-[9px] uppercase tracking-wider font-bold text-gray-500 whitespace-nowrap">{k.label}</div>
            <div className="text-xl font-extrabold leading-none mt-1" style={{ color: k.color || '#0A0A0A' }}>{k.value}</div>
          </button>
        ))}
      </div>

      {/* Zoek + filters */}
      <div className="flex gap-2 mb-2">
        <div className="relative flex-1">
          <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <input className="field-input h-11 w-full" style={{ paddingLeft: 36 }} placeholder="Zoek op klant of nummer..." />
        </div>
        <button className={`h-11 px-3 inline-flex items-center gap-1.5 border text-sm font-semibold ${filtersOpen ? 'bg-[#002FA7] text-white border-[#002FA7]' : 'bg-white border-gray-300 text-gray-700'}`} onClick={() => setFiltersOpen(v => !v)}>
          <Funnel size={16} weight="bold" /> Filters <span className="bg-[#EA580C] text-white text-[10px] rounded-full w-4 h-4 inline-flex items-center justify-center">1</span>
        </button>
      </div>
      {filtersOpen && (
        <div className="bg-white border border-gray-200 p-3 mb-3 grid grid-cols-1 sm:grid-cols-2 gap-2">
          <select className="field-input h-11"><option>Alle statussen</option></select>
          <div className="flex gap-2"><input type="date" className="field-input h-11 flex-1" defaultValue="2026-10-01" /><input type="date" className="field-input h-11 flex-1" /></div>
          <div className="flex gap-1.5 flex-wrap col-span-full">
            {['Deze maand', 'Vorige', 'Dit jaar'].map(t => <button key={t} className="h-9 px-3 text-xs bg-gray-100 border border-gray-200">{t}</button>)}
            <button className="h-9 px-3 text-xs text-red-600 ml-auto">Filters wissen</button>
          </div>
        </div>
      )}
      <div className="flex items-center justify-between text-xs text-gray-400 mb-2">
        <label className="inline-flex items-center gap-2"><input type="checkbox" className="w-5 h-5" /> Alles selecteren</label>
        <span>112 van 112</span>
      </div>

      {/* Kaartjes: 1 kolom gsm, 2 kolommen iPad */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2.5">
        {DOCS.map(d => <DocCard key={d.id} d={d} selected={sel.includes(d.id)} onToggle={() => toggle(d.id)} />)}
      </div>

      {/* Vaste actiebalk onderaan (enkel bij selectie) */}
      {N > 0 && (
        <div className="fixed left-0 md:left-56 right-0 bottom-0 z-40 bg-white border-t-2 border-[#002FA7] shadow-[0_-4px_16px_rgba(0,0,0,0.08)]" style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}>
          {moreOpen && (
            <div className="grid grid-cols-2 gap-2 p-3 border-b border-gray-100 bg-[#F8FAFC]">
              {['⚙ Status wijzigen', '📄 PDF-ZIP', '🖨 PDF\u2019s openen', '📨 Verzendmelding', '🗑 Verwijderen'].map(t => (
                <button key={t} className="h-11 px-3 text-sm font-semibold bg-white border border-gray-200 text-left">{t}</button>
              ))}
            </div>
          )}
          <div className="flex items-center gap-2 px-3 py-2.5">
            <button className="h-11 w-11 inline-flex items-center justify-center border border-gray-200 text-gray-500" onClick={() => setSel([])}><X size={18} weight="bold" /></button>
            <span className="text-sm font-bold text-[#002FA7] whitespace-nowrap">{N} gesel.</span>
            <div className="flex-1 min-w-0 flex gap-1.5 overflow-x-auto" style={{ scrollbarWidth: 'none' }}>
              <button className="h-11 px-3 shrink-0 bg-[#002FA7] text-white text-sm font-bold inline-flex items-center gap-1"><Truck size={16} weight="bold" /> Verzenden</button>
              <button className="h-11 px-3 shrink-0 bg-[#16A34A] text-white text-sm font-bold inline-flex items-center gap-1"><Check size={16} weight="bold" /> Geleverd</button>
              <button className="h-11 px-3 shrink-0 bg-[#7C3AED] text-white text-sm font-bold">Factureren</button>
            </div>
            <button className={`h-11 w-11 shrink-0 inline-flex items-center justify-center border ${moreOpen ? 'bg-[#002FA7] text-white border-[#002FA7]' : 'border-gray-300 text-gray-700'}`} onClick={() => setMoreOpen(v => !v)}><DotsThreeVertical size={20} weight="bold" /></button>
          </div>
        </div>
      )}
    </div>
  );
}
